import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p className="footer-tagline">Hacemos visible lo invisible</p>

      <div className="footer-stores">
        <a
          className="store-btn"
          href="https://play.google.com/store/apps/details?id=com.aldealista"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-android" aria-hidden="true"></i>
          <span className="store-lines">
            <small>Disponible en</small>
            <b>Google Play</b>
          </span>
        </a>

        <a
          className="store-btn"
          href="https://apps.apple.com/es/app/aldealista/id1658806105"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-apple" aria-hidden="true"></i>
          <span className="store-lines">
            <small>Descárgalo en</small>
            <b>App Store</b>
          </span>
        </a>
      </div>

      <a
        className="footer-brand"
        href="https://aldealista.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        aldealista.com
      </a>
    </footer>
  );
}

export default Footer;
